import { createApp } from 'vue'
import App from './App.vue'
import './style.css'

console.log('🔧 main.js 시작');

try {
  // Vue 앱 생성 및 마운트
  console.log('🎯 Vue 앱 생성 중...');
  const app = createApp(App)

  // 에러 핸들링 추가
  app.config.errorHandler = (err, vm, info) => {
    console.error('❌ Vue 앱 에러:', err);
    console.error('📍 에러 정보:', info);
  }

  // 글로벌 속성 설정
  console.log('⚙️ 글로벌 속성 설정 중...');
  app.config.globalProperties.$formatNumber = (num) => {
    return new Intl.NumberFormat('ko-KR').format(num)
  }

  app.config.globalProperties.$formatDate = (date) => {
    return new Intl.DateTimeFormat('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date(date))
  }

  console.log('🚀 Vue 앱 마운트 중...');
  app.mount('#app')
  console.log('✅ Vue 앱 마운트 성공!');
  
} catch (error) {
  console.error('❌ main.js에서 치명적 오류 발생:', error);
} 